<template>
  <div class="warehouse">
    <div class="nav">
      <el-form :model="form" label-width="100px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="委托商仓库名称:" label-width="120px">
          <el-input v-model="form.warehouseName" size="mini" placeholder="请输入合同名称"></el-input>
        </el-form-item>
        <el-form-item label="委托商名称:">
          <el-input v-model="form.customerName" size="mini" placeholder="请输入合同名称"></el-input>
        </el-form-item>

        <el-form-item label="合同状态:">

          <el-select v-model="form.status" filterable size="mini" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用中" value="1"></el-option>
            <el-option label="禁用中" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index" :index="tableIndexMethod">

          </el-table-column>
          <el-table-column prop="warehouseName" label="委托商仓库" align="center"/>
          <el-table-column prop="customerName" label="委托商名称" align="center"/>
          <el-table-column prop="addr" label="详细地址" align="center" width="400">
            <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis" slot-scope="scope">{{scope.row.addr}}</div>
          </el-table-column>
          <el-table-column prop="createTime" label="添加时间" align="center">
            <template slot-scope="scope">
              {{scope.row.createTime | createTimeFormat}}
            </template>
          </el-table-column>
          <el-table-column prop="statusStr" label="状态" align="center" width="140">
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
                <el-button  size="mini" type="danger" @click="DisableClick(scope.row.id, scope.row)" v-if="scope.row.status ==1 ">禁用</el-button>
                <el-button size="mini" type="primary" @click="EnableClick(scope.row.id, scope.row)" v-if="scope.row.status ==0 ">启用</el-button>
                <el-button size="mini"  class="yellow-bg"  @click="modifyClick(scope.row)">修改</el-button>
                <el-button size="mini"  type="info" @click="deleteClick(scope.row)" v-if="scope.row.state ==2 ">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>

    <el-dialog :title="`${dialogTitle}委托商仓库`" :visible.sync="addflag" width='623px' center @close="dialogClose">
      <div class="add">
        <el-form :model="addform" label-width="100px"  :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item label="委托商仓库:" prop="warehouseName">
            <el-input size="mini"  v-model="addform.warehouseName" placeholder="请输入委托商仓库名称"></el-input>
          </el-form-item>
          <el-form-item label="委托商:" prop="customer">
            <el-select size="mini" v-model="addform.customer" filterable value-key="id">
              <el-option v-for="(item,index) in consignorOption" :label="item.customer_name"
                         :value="item" :key="`${index}cd`" placeholder="请选择委托商"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址:" prop="address">
            <el-input size="mini"  v-model="addform.address" placeholder="请输入地址">
              <i class="el-input__icon el-icon-location-outline" style="" slot="suffix"
                 @click="showMap = true"></i>
            </el-input>
          </el-form-item>
<!--          <el-form-item label="详细地址:" prop="type">-->

<!--          </el-form-item>-->
        </el-form>
        <div class="btnContainer">
          <el-button class="searchBtn" size="medium" :loading="addLoad" @click="addClick()">{{dialogTitle}}</el-button>
          <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
        </div>
      </div>


    </el-dialog>
    <popup title="选择位置" width="600" :show.sync="showMap" style="z-index:9999">
      <selectMap @close="closeMap" useType="select" :address="addform.address"></selectMap>
    </popup>
  </div>
</template>

<script>
  import {
    customerWarehouseInfoPageList,
    customerInfoSelectList,
    customerWarehouseInfoIsEnable,
    customerWarehouseInfoDetail,
    customerWarehouseInfoAdd,
    customerWarehouseInfoUpdate,
    customerWarehouseInfoStatusSelectList
  } from "@/service/basicfile";
  import {
    formatTime
  } from "@/config/mUtils";
  import popup from "@/components/popup";
  import selectMap from "@/components/map";
  export default {
    components: {
      popup,
      selectMap,
    },

    data() {
      return {
        form:{
          warehouseName:"",
          customerName:'',
          status:"",
          page:1,
          rows:10,

        },
        total:0,
        tableLoad:false,
        TableDatas:[],
        addform:{
          warehouseName:'',
          customer:'',
          address:"",
          coordinates:'',
        },
        dialogTitle:'',
        consignorOption:[],
        showMap:false,
        modifyform:{
          name:'',
          remark:'',
        },
        DialogVisible:false,
        addflag:false,
        modifyflag:false,
        addLoad: false,
        modifyId:'',
        rules:{
          warehouseName:{ required: true, message: '请输入委托商仓库名称', trigger: 'blur' },
          customer:{ required: true, message: '请选择委托商', trigger: 'blur' },
          address:{ required: true, message: '请输入地址', trigger: 'blur' },
        }
      };

    },
    filters:{
      createTimeFormat:function(value){
        console.log(value)
        if(value){
          return formatTime(value, "yyyy-mm-dd hh:ii:ss")
        }else {
          return ''
        }

      }
    },
    created() {
      this.$nextTick(()=>{
        this._customerWarehouseInfoPageList()

      })
    },
    methods: {
      async _customerWarehouseInfoPageList(){
        this.tableLoad = true
        let res = await  customerWarehouseInfoPageList(this.form)
        this.tableLoad = false
        if (res.status !== 0) return  this.$message.error(res.message)
        this.TableDatas = res.data.records
        this.total = res.data.total

      },
      async _customerInfoSelectList(){
        let res =await customerInfoSelectList()
        if (res.status !==0) return this.$message.error(res.message)
        this.consignorOption = res.data

      },
      closeMap(val, lnglat) {
        //   debugger;
        if (!val || !lnglat[0] || !lnglat[1]) {
          this.$message.error("获取地址失败");
          return;
        }
        this.addform.address = val;
        this.addform.coordinates =lnglat;
        this.centerP = lnglat
        console.log(this.centerP);

        this.showMap = false;
        // this.coordinate(lnglat)
      },
      searchBtn(){
        this.form.page = 1;
        this._customerWarehouseInfoPageList()
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ''
        }
        this.form.page = 1
        this.form.rows = 10

      },
      tableIndexMethod(index) {
        return this.form.rows * (this.form.page - 1) + index + 1;
      },
      addBtn(){
        this.dialogTitle = '添加'
        this.addflag = true
        this._customerInfoSelectList()
      },
      contractSizeChange(row){
        this.form.rows=row;
        this._customerWarehouseInfoPageList()
      },
      contractCurrentChange(page){
        this.form.page=page;
        this._customerWarehouseInfoPageList()
      },

      deleteClick(row){
        this.$confirm('确认要删除当前委托商仓库吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await contractTypeDelete(row.id);
          if (res.status !==0)   return  this.$message.error(res.message);
          this.$message.success(res.message);
          await this._customerWarehouseInfoPageList()
        }).catch(() => {});
      },
      EnableClick(id,row){
        this.$confirm('确认要启用当前委托商仓库吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res =await customerWarehouseInfoIsEnable(id)
          if (res.status!==0) {
            return  this.$message.error(res.message);

          }
          await this._customerWarehouseInfoPageList()
          this.$message.success(res.message);

        }).catch(() => {});
      },
      DisableClick(id,row){
        this.$confirm('确认要禁用当前委托商仓库吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res =await customerWarehouseInfoIsEnable(id)
          if (res.status!==0) {
            return  this.$message.error(res.message);
          }
          await this._customerWarehouseInfoPageList()
          this.$message.success(res.message);


        }).catch(() => {});
      },
      async addClick(){
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid){
            this.addLoad = true;
            let {warehouseName,customer,coordinates,address} =this.addform
            let data ={
              warehouseName:warehouseName,
              customerId:customer.id,
              customerName:customer.customer_name,
              addr:address,
              longitude:coordinates[0],
              latitude:coordinates[1]
            }
            if ( this.dialogTitle==='添加'){
              let res =await customerWarehouseInfoAdd(data)
              this.addLoad = false;
              if (res.status !==0){ return  this.$message.error(res.message); }
              this.$message.success(res.message);
              await this._customerWarehouseInfoPageList()
            }else {
              data.id = this.addform.id
              let res2 = await customerWarehouseInfoUpdate(data)
              this.addLoad = false;
              if (res2.status !==0){ return  this.$message.error(res2.message); }
              this.$message.success(res2.message);
              await this._customerWarehouseInfoPageList()
            }
            this.dialogClose()
          }else {
            console.log('error submit!!');
          }
        })

      },
      dialogClose(){
        this.$refs.ruleForm.resetFields();
          this.addflag = false
          for (const argumentsKey in this.addform) {
            this.addform[argumentsKey] = ''
          }


      },
      modifyClick(row){
        this.dialogTitle = '修改'
        this.addflag = true
        this._customerInfoSelectList()
        let {addr,customerId,customerName,id,latitude,longitude,warehouseName} =row
        this.addform={
          id:id,
          warehouseName:warehouseName,
          customer:{id:customerId,customer_name:customerName},
          address:addr,
          coordinates:[longitude,latitude],
        }

      },
    },
  };
</script>



<style lang="scss" scoped>
  .warehouse{
    /*width:100%;*/
    padding:20px 15px 0 25px;
    /*height: 100%;*/
    /*overflow: auto;*/
    .nav{
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content{

    }
    ::v-deep.add{
      padding: 26px 40px;
      .el-input{
        width: 280px;
      }
      .el-form-item__label{
        /*color: #060606;*/
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom: 20px;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      margin-top: 35px;
      button{
        margin: 0 15px;
      }
    }

  }
  ::v-deep{

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      color: #606266;
    }


  }
</style>
